import {
  useMutation,
  useQuery
} from '@tanstack/vue-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query'
import {
  computed,
  unref
} from 'vue'
import type {
  MaybeRef
} from 'vue'
import type {
  ApiGetLeadsParams,
  BackendErrorEntity,
  GetLeadsResponseDto,
  LeadEntity,
  PostLeadBodyDto
} from '.././types'
import { fetchApiInstance } from '../../fetchApiInstance';
import type { ErrorType, BodyType } from '../../fetchApiInstance';


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const apiPostLead = (
    postLeadBodyDto: MaybeRef<PostLeadBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      postLeadBodyDto = unref(postLeadBodyDto);
      
      return fetchApiInstance<LeadEntity>(
      {url: `/leads`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postLeadBodyDto
    },
      options);
    }
  


export const getApiPostLeadMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiPostLead>>, TError,{data: BodyType<PostLeadBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiPostLead>>, TError,{data: BodyType<PostLeadBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiPostLead>>, {data: BodyType<PostLeadBodyDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiPostLead(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiPostLeadMutationResult = NonNullable<Awaited<ReturnType<typeof apiPostLead>>>
    export type ApiPostLeadMutationBody = BodyType<PostLeadBodyDto>
    export type ApiPostLeadMutationError = ErrorType<BackendErrorEntity>

    export const useApiPostLead = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiPostLead>>, TError,{data: BodyType<PostLeadBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiPostLead>>,
        TError,
        {data: BodyType<PostLeadBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiPostLeadMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiGetLead = (
    leadId: MaybeRef<string | undefined | null>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      leadId = unref(leadId);
      
      return fetchApiInstance<LeadEntity>(
      {url: `/admin/leads/${leadId}`, method: 'GET'
    },
      options);
    }
  

export const getApiGetLeadQueryKey = (leadId: MaybeRef<string | undefined | null>,) => {
    return ['admin','leads',leadId] as const;
    }

    
export const getApiGetLeadQueryOptions = <TData = Awaited<ReturnType<typeof apiGetLead>>, TError = ErrorType<BackendErrorEntity>>(leadId: MaybeRef<string | undefined | null>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetLead>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiGetLeadQueryKey(leadId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiGetLead>>> = () => apiGetLead(leadId, requestOptions);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(leadId))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiGetLead>>, TError, TData> 
}

export type ApiGetLeadQueryResult = NonNullable<Awaited<ReturnType<typeof apiGetLead>>>
export type ApiGetLeadQueryError = ErrorType<BackendErrorEntity>



export function useApiGetLead<TData = Awaited<ReturnType<typeof apiGetLead>>, TError = ErrorType<BackendErrorEntity>>(
 leadId: MaybeRef<string | undefined | null>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetLead>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiGetLeadQueryOptions(leadId,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



export const apiGetLeads = (
    params?: MaybeRef<ApiGetLeadsParams>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      params = unref(params);
      
      return fetchApiInstance<GetLeadsResponseDto>(
      {url: `/admin/leads`, method: 'GET',
        params: unref(params)
    },
      options);
    }
  

export const getApiGetLeadsQueryKey = (params?: MaybeRef<ApiGetLeadsParams>,) => {
    return ['admin','leads', ...(params ? [params]: [])] as const;
    }

    
export const getApiGetLeadsQueryOptions = <TData = Awaited<ReturnType<typeof apiGetLeads>>, TError = ErrorType<BackendErrorEntity>>(params?: MaybeRef<ApiGetLeadsParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetLeads>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiGetLeadsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiGetLeads>>> = () => apiGetLeads(params, requestOptions);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiGetLeads>>, TError, TData> 
}

export type ApiGetLeadsQueryResult = NonNullable<Awaited<ReturnType<typeof apiGetLeads>>>
export type ApiGetLeadsQueryError = ErrorType<BackendErrorEntity>



export function useApiGetLeads<TData = Awaited<ReturnType<typeof apiGetLeads>>, TError = ErrorType<BackendErrorEntity>>(
 params?: MaybeRef<ApiGetLeadsParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetLeads>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiGetLeadsQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



